/**
 * @module Flash
 */

export enum ActionType {
  SHOW = 'APP::FLASH::SHOW',
  CLEAR = 'APP::FLASH::CLEAR',
}

export enum Action {
  SHOW = 'SHOW',
  CLEAR = 'CLEAR',
}

export interface Options {
  duration: number;
  isDismissible?: boolean;
  isError?: boolean;
  message: string;
}

export interface ClearPayload {
  readonly id?: string;
}

export interface Payload extends Options {
  readonly id?: string;
}



// WEBPACK FOOTER //
// ./src/actions/Flash/types.ts